export default {
    group: {
        members: 'Members',
        name: 'Name',
        title: 'Create Group',
        titleSub:
            'Documents and clients owned by a group are only visible to members of the group',
    },
    role: {
        members: 'Members',
        name: 'Role Name',
        title: 'Create Role',
        titleSub:
            'Assign team members to different functional roles within your company',
    },
};
